import {vuetify} from "@/main.js";
import WhitelabelFileTypes from '@/enums/WhitelabelFileTypes'

export function setThemeColors(colors) {
  vuetify.framework.theme.themes.light = colors
}

export function setFavicon(favicon) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = favicon;
}

export function setLogos(logos) {
  let meta = document.querySelector("meta[property='og:image']");
  if (!meta) {
    meta = document.createElement('meta');
    meta.property = 'og:image';
    document.head.appendChild(meta);
  }
  meta.content = logos;
}

export function setFonts(config) {
  const fonts = config.fonts;
  if (fonts) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fonts;
    document.head.appendChild(link);
  }

  if (config.font && config.font.url) {
    const font = document.createElement('link');
    font.href = config.font.url;
    font.rel = 'stylesheet';
    document.head.appendChild(font);

    const css = document.createElement('style');
    css.innerHTML = `body { font-family: '${config.font.name}', sans-serif !important; }`;
    document.head.appendChild(css);
  }
}
export function extractFontFamily(cssContent) {
  const match = cssContent?.match(/font-family:\s*['"]?([^;'"]+)['"]?;/i)
  return match ? match[1] : null
}

export function extractAllFontFamilies(cssContent) {
  const regex = /font-family:\s*['"]?([^;'"]+)['"]?;/gi
  const matches = [...cssContent.matchAll(regex)]
  return matches.map(match => match[1])
}

export function extractFontTypesAndFamilies(cssContent) {
  const results = []
  const regex = /\/\*type:(\d+)\*\/\s*@font-face\s*{[^}]*font-family:\s*['"]([^'"]+)['"]/gi

  let match
  while ((match = regex.exec(cssContent)) !== null) {
    results.push({
      type: parseInt(match[1], 10),
      fontFamily: match[2]
    })
  }
  return results
}
export function setFontsCss(fontCSS) {
  const fontFamilies = extractFontTypesAndFamilies(fontCSS);

  const existing = document.querySelector('style[data-font-whitelabel]');
  if (existing) existing.remove();

  if (!fontFamilies?.length) {
    const defaultFont = extractFontFamily(fontCSS);
    if (defaultFont) {
      document.documentElement.style.setProperty('--font-heading', `'${defaultFont}', sans-serif`);
      document.documentElement.style.setProperty('--font-body', `'${defaultFont}', sans-serif`);
    }
  }

  const style = document.createElement('style');
  style.type = 'text/css';
  style.setAttribute('data-font-whitelabel', '');
  style.textContent = fontCSS;

  document.head.appendChild(style);

  fontFamilies?.forEach(font => {
    const cssVariable = font.type === WhitelabelFileTypes.PrimaryFont ? '--font-heading' : '--font-body';
    document.documentElement.style.setProperty(cssVariable, `'${font.fontFamily}', sans-serif`);
  });

}

export function setCustomCSS(css) {
  if (css) {
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
  }
}
